module.exports = __webpack_public_path__ + "img/phone.ebd122bc.svg";